"use client"; 

import AppLogo from "../apps/logo";
import SourceLogo from "../apps/sourceLogo";
import { capitalize } from "@/lib/format";
import { automationURL } from "@/lib/helpers";


export default function AutomationsGridItem({ extAutomation }) {
  if (!extAutomation?.id) return <></>
  
  return (
    <div className="h-full relative p-3  bg-gray-100 border border-gray-200 rounded hover:border-crisp-600">
      {/* Logos Block - source and apps */}
      <div className="flex space-x-3 relative overflow-hidden">                       

        {/* Apps Logos */}
        <div className='flex border-gray-200 border rounded-md bg-white'>
          {extAutomation?.external_automation_actions?.map(item => item?.app)?.map((app, appIndex) => (                          
            <div key={appIndex} className="p-1  border-gray-200 border-r ">
              <AppLogo app={app} className='relative inline-block h-10 w-10 rounded-md text-white'/>                    
            </div>
          ))}
        </div>

        {/* Source Logo */}
        <div key={`${extAutomation?.id}-source-logo`} className="p-1 border border-gray-200 rounded-md bg-white">
          <SourceLogo 
            source={{ 
              slug: extAutomation?.source_slug || extAutomation?.source?.slug, 
              name: extAutomation?.source_slug 
            }} 
            className='relative  inline-block h-10 w-10 rounded-md'
          />
        </div>                     
      </div>

      {/* Description Block - name, etc */}
      <div className="mt-3">
        <a
          href={automationURL({ extAutomation })}
          className="text-gray-700 hover:text-crisp-600"
        >
          <span className="absolute inset-0" aria-hidden="true"></span>

          <h3 className="text-base font-medium ">
            {extAutomation?.name} using {capitalize(extAutomation?.source_slug || extAutomation?.source?.slug)}
          </h3>

        </a>
      </div>
    </div>
  ) 

}



